import type { IconName } from '@sparklayer-io/spark-dash-ui/components/ui/icon/types';
import { cn } from '@sparklayer-io/spark-dash-ui/lib/styles';
import { Icon } from '@ui/themed';
import type { ReactNode } from 'react';

type StatusBannerTone = 'blue' | 'green';

const TONE_CLASSES: Record<StatusBannerTone, { frame: string; tile: string; title: string }> = {
  blue: { frame: 'border-blue-300 bg-blue-50', tile: 'bg-blue-400', title: 'text-blue-800' },
  green: { frame: 'border-green-300 bg-green-50', tile: 'bg-green-400', title: 'text-green-800' },
};

export function StatusBanner({
  tone,
  icon,
  title,
  description,
  onClick,
}: {
  tone: StatusBannerTone;
  icon: IconName;
  title: string;
  description: ReactNode;
  onClick: () => void;
}) {
  const tones = TONE_CLASSES[tone];

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex w-full items-stretch overflow-clip rounded-xl border text-start shadow-sm',
        tones.frame,
      )}
    >
      <span
        className={cn('flex w-14 shrink-0 items-start justify-center pt-4 text-white', tones.tile)}
      >
        <Icon name={icon} size="lg" />
      </span>
      <span className="flex flex-1 items-center justify-between gap-4 p-4">
        <span className="flex flex-col gap-1">
          <span className={cn('font-medium text-sm', tones.title)}>{title}</span>
          <span className="text-sm text-spark-text-secondary">{description}</span>
        </span>
        <Icon name="chevronRight" />
      </span>
    </button>
  );
}
